import type {EditorState} from "prosemirror-state";
import type {EditorView} from "prosemirror-view";
import type {Transaction} from "prosemirror-state";


export interface NodeViewAdditionalParams {
  getPos: () => number | undefined,
}


export const createSetNodeAttributeCommand = (attrName: string, value: any) =>
  (
    state: EditorState,
    dispatch?: (tr: Transaction) => void,
    view?: EditorView,
    params?: NodeViewAdditionalParams
  ): boolean => {
    const pos = params?.getPos?.();
    if (pos === undefined) return false;

    const node = state.doc.nodeAt(pos);
    if (!node) return false;

    if (dispatch) {
      if (node.type.spec.attrs?.[attrName]) {
        if (node.attrs[attrName] !== value) {
          dispatch(state.tr.setNodeAttribute(pos, attrName, value));
        }
        return true;
      }
    }
    return false;
  };
